import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setProcessModalOpen,
        setProcessPage,
        get_process_list,
        create_process,
        update_process,
        setAction,
        setId,
        setStatus,
        setSearchQuery,
        activate_deactivate_process,
        get_process_details  
 } from "../../../store/process/processSlice";
const mapStateToProps = (state) => {
  const {
      is_process_modal_open,
      process_list,
      common_loading,
      total_process_count,
      active_process,
      page,
      c_action,
      process_id,
      selected_status,
      search_query,     
      selected_data
    } = state.process;
  return {
      is_process_modal_open : is_process_modal_open,
      process_list : process_list,
      total_process_count : total_process_count,
      common_loading : common_loading,
      active_process : active_process,
      page : page,
      c_action : c_action,
      process_id : process_id,
      selected_status : selected_status,
      search_query : search_query,
      selected_data : selected_data,
      
  };
  };
  
  const mapDispatchToProps = (dispatch) =>
      bindActionCreators({
      setProcessModalOpen,
      setProcessPage,
      get_process_list,
      create_process,
      update_process,
      setAction,
      setId,
      setStatus,
      setSearchQuery,
      activate_deactivate_process,
      get_process_details
      }, dispatch);
  
  const Store = (Container) =>
      connect(mapStateToProps, mapDispatchToProps)(Container);
  
export default Store;